export default {
    route_orders: null,
    route_map: null,
    route_map_center: null,
    route_path_bounds: null,
    route_modal_date: null,
    route_map_review_path_bounds: null,
    route_map_review: null,
    route_map_review_center: null,
    route_workers_all: null,
    current_color_key: null,
    route_map_markers: [],
    route_vehicles: [],
    route_map_review_markers: [],
    workers_by_orders: [],

    init: function() {

        let $this = this;
        
        $('body').on('click', '.route-info-button', function(e) {
            $this.getRouteInfo($(this));
        });

        $('body').on('click', '.optimize-button', function(e) {
            $this.routeMapOptimize($(this));
        });

        $('body').on('click', '.review-button', function(e) {
            $this.RouteMapModalReview($(this).data('worker_id'), $(this).data('color_key'));
        });        

        $('body').on('click', '#route-review-recalculate-button', function(e) {
            $this.routeReviewMapRecalculate($(this));
        });    

        $('body').on('click', '#route-review-optimize-button', function(e) {
            $this.RouteReviewMapOptimize($(this));
        });

        $('body').on('change', '.worker-selector-route', function(e) {            
            $this.RouteMapModelWorkerSelected(
                $(this).val(),
                $(this).data('old_worker_id'), 
                $(this).data('order_id'),
            );
        });

        $('body').on('click', '.address-error-edit-button', function(){
            let customer_id = $(this).data('customer_id');

            $.ajax({
                type: 'GET',
                url: '/cockpit/user_info_edit/' + customer_id,
                success: function (response) {
                    $('#ajax_modals_containter').html(response);
                    $('#user_info_edit_modal').css('z-index', 10000).modal('show');
                    $('.customer-info-submit-form').attr('type', 'button').data('customer_id', customer_id);
                    $("#user-info-form input[name='_method']").val("POST");
                }
            });            
        });

        $('body').on('click', '.customer-info-submit-form', function() {
            let new_customer_data = $('#user-info-form').serializeArray().reduce(function(obj, item) {
                obj[item.name] = item.value;
                return obj;
            }, {});

            let customer_id = $('.customer-info-submit-form').data('customer_id');
            new_customer_data.id = customer_id;

            $.ajax({
                type: 'POST',
                url: '/customers/' + customer_id + '/update',
                data: new_customer_data,
                success: function (response) {
                    $('#user_info_edit_modal').modal('hide');
                    $("#address_errors_table tr[customer_id='" + customer_id + "'] .address-error-address")
                        .html($("#user-info-form input[name='address']").val());
                    $("#address_errors_table tr[customer_id='" + customer_id + "'] .address-error-zipcode")
                        .html($("#user-info-form input[name='zip_code']").val());
                }
            });                      
        });

        $('body').on('click', '.locate-again-button', function() {
            $('.route-info-button[data-date="' + $(this).data('date') + '"]').trigger('click');
        });
        
    },

    showOrdersMapByDate: function() {
        $('head script[src*="maps.googleapis.com/maps-api-v3"]').remove();
        $('head script[src*="maps.googleapis.com/maps/api"]').remove();
        $('#app').off('click', 'a[data-show-map]').on('click', 'a[data-show-map]', function(e){
            e.preventDefault();
            let ordersDate = $(this).data('map-date');
            const dateRange = {
                'date-range': {
                    start: ordersDate,
                    end: ordersDate
                }
            }
            $.ajax({
                type: 'GET',
                data: dateRange,
                url: '/service-list/get-orders-map-by-date/',
                success: function (response) {
                    $('#form-container').html(response);
                    $('#map-modal').modal('show');
                    $('#close-map-button').off('click').on('click',()=>{
                        $('head script[src*="maps.googleapis.com/maps-api-v3"]').remove();
                        $('head script[src*="maps.googleapis.com/maps/api"]').remove();
                    })
                }
            });
        });
    },
    
    showWarningModal: function() {
        $('body').on('click', '.warning-info-icon', function(e) {
            $('.order-reason').text($(this).data('reason'));
            if ($(this).data('reason')!=='') {
                $('.order-reason').parent().addClass('mb-30');
            }
            $('.remove_warning').data('class_id', $(this).data('class_id'));
            $('.remove_warning').data('class_type', $(this).data('class_type'));
            $('#order-warning-modal').modal('show');
        });
    },

    initPagination: function() {
        if (window.location.pathname == '/service-list') {
            let section = new Section('orders', true);
            section.show();
        }
    },

    mobileActionsInit: function() {
        const modalWindow = $(`#${$('#mobile-actions-btn').data('target')}`)
        modalWindow.removeClass('d-flex');
        modalWindow.addClass('d-none');
        $('#mobile-actions-btn').off('click').on('click', ()=>{
            if (modalWindow.hasClass('d-flex')) {
                modalWindow.addClass('d-none');
                modalWindow.removeClass('d-flex');
            } else {
                modalWindow.removeClass('d-none');
                modalWindow.addClass('d-flex');
            }
            const top = $('#mobile-actions-btn').offset().top + 40;
            const right = window.innerWidth - $('#mobile-actions-btn')[0].getBoundingClientRect().right;
            modalWindow.css({
                'opacity': 1,
                'display': 'flex',
                'right': right,
                'top': top,
            });
            const popupOffset = modalWindow[0].getBoundingClientRect();
            if (popupOffset.height + popupOffset.top > window.innerHeight + window.scrollY / 4) {
                modalWindow.css({
                    'right': right + 40,
                    'top': window.innerHeight + window.scrollY - popupOffset.height - 20
                });
            }
        })
    },

    openAddressErrorsModal: function(customers, date) {
        let table = $('#address_errors_table tbody');
        table.html('');
        let count = 1;

        for (let customer of customers) {
            let tr = $('#address_errors_tr_template').contents().clone();

            if (count === 1) tr.addClass('border-none');

            tr.attr('customer_id', customer.id);
            tr.find('.address-error-name').html(customer.first_name + " " + customer.last_name);
            tr.find('.address-error-address').html(customer.address);
            tr.find('.address-error-zipcode').html(customer.zip_code);
            tr.find('.address-error-edit-button').data('customer_id', customer.id);
            table.append(tr);

            count++;
        }

        $('.locate-again-button').data('date', date);
        $('#route_map_address_errors_modal').modal('show');
    },

    
    
    getRouteInfo: function(elem) {
        let $this = this;

        $.ajax({
            type: 'GET',
            data: {
                date: elem.data('date'),
            },
            url: '/service-list/route/info',
            success: function (response) {
                $this.route_orders = response.orders;

                let customersWithoutCoords = [];

                for (let order of response.orders) {
                    if (!order.user_lat || !order.user_lon) {
                        customersWithoutCoords.push(order.customer);
                    }
                }

                if (customersWithoutCoords.length > 0) {
                    $this.openAddressErrorsModal(customersWithoutCoords, elem.data('date'));
                    return;
                } else {
                    $('#route_map_address_errors_modal').modal('hide');
                }

                $this.route_modal_date = response.date;
                $this.route_workers_all = response.workers_all;

                let workers_by_orders = [];
                
                for (let order of response.orders) {
                    let workers_from_current_order = [];
                    
                    for (let worker of order.workers) {

                        workers_from_current_order.push(worker.id);
                    }

                    workers_by_orders["order_" + order.id] = workers_from_current_order;
                }

                $this.workers_by_orders = workers_by_orders;

                $('#route-map-modal-date').html(response.date_string);
                $('#route-map-modal-orders-counts').html('(Orders: ' + response.orders_count + ")");

                var route_path_coords = [{
                    lat: 40.7198749,
                    lng: -73.985987
                }];                    

                response.orders.forEach(function(item){
                    route_path_coords.push({
                        lat: parseFloat(item.user_lat),
                        lng: parseFloat(item.user_lon)
                    });
                });

                $this.RouteMapSetVehicles(response.workers);

                console.log(route_path_coords);

                $this.RouteDisplayMap();

                $('#route-map-modal').modal('show');
            }
        });            
    },

    routeMapOptimize: function(elem) {
        if (typeof elem.data('color_key') !== undefined) this.current_color_key = elem.data('color_key');

        let $this = this;
        let worker_id = elem.data('worker_id');

        elem.css('display', 'none');            
        $('.optimize-loading-' + worker_id).css('display', 'inline-block');
                    
        $.ajax({
            type: 'POST',
            url: '/service-list/route/create',
            data: ({
                date: $this.route_modal_date,
                worker_id: worker_id,
            }),
            success: function (response) {                   
                if (response && response.responseJSON && response.responseJSON.errors && response.responseJSON.errors.length > 0) {
                    showErrorModal('Error: ' + response.responseJSON.errors.join(','));
                } else {
                    // $this.RouteMapSetVehicles(response.vehicles);
                    $this.RouteMapModalReview(response.worker_id);
                }
            },
            error: function (response) {
                console.log('response error: ', response.responseJSON.errors);
                if (response.responseJSON.errors  && response.responseJSON.errors.length > 0) {
                    showErrorModal('Error: ' + response.responseJSON.errors.join(','));
                } else {
                    showErrorModal();
                }
            },
            complete: function (response) {
                $('.optimize-loading-' + worker_id).css('display', 'none');
                elem.css('display', '').prop('disabled', true)
                    .addClass('`cl-button-gray`')
                    .removeClass('cl-button');
                $('.review-button[data-worker_id="' + worker_id + '"]')
                    .prop('disabled', false)
                    .addClass('cl-button')
                    .removeClass('cl-button-gray');
            }
        });
    },      

    routeReviewMapRecalculate: function(elem) {
        let $this = this;
        let data = elem.data();

        console.log('Recalculate button data: ', data);

        if(data.vehicle_route_id) {

            $('#route-map-review-list').html('<div style="text-align: center; font-size: 2em;">' +
                'Recalculate...' +
                '</div><div style="text-align: center;">(Please wait)<div>');

            $('#route-map-review-action').hide();

            $.ajax({
                type: 'POST',
                url: '/service-list/route/recalculate',
                data: ({
                    vehicle_route_id: data.vehicle_route_id,
                }),
                success: function (response) {
                    console.log('route-recalculate-route-by-id (response): ', response);
                    $('#route-map-modal-review').modal('hide');

                    setTimeout(() => {
                        $this.RouteMapModalReview(data.worker_id);
                    }, 500);
                },
                error:  function (jqXHR, exception) {
                    console.error('ERROR: route-recalculate-route-by-id: ', jqXHR.responseJSON.message);
                    alert(jqXHR.responseJSON.message);
                }
            });

        } else {

            console.error('ERROR: data.vehicle_route_id is empty');
            alert("Don't exist route");
        }
    },      

    RouteReviewMapOptimize: function(elem) {
        let $this = this;
        let data = elem.data();

        console.log('Optimize button data: ', data);
        $this.routeMapOptimize(elem);

        $('#route-map-review-action').hide();

        setTimeout(() => {
            $this.RouteMapModalReview(data.worker_id);
        }, 1000);
    },     

    RouteDisplayMap: function() {
        this.route_map_center = new google.maps.LatLng(40.7198749, -73.985987);

        var mapCanvas = document.getElementById('route-map');

        var mapOptions = {
            zoom: 12,
            mapTypeId: google.maps.MapTypeId.ROADMAP,
            disableDefaultUI:  false ,
            scrollwheel:  true ,
            zoomControl:  true ,
            mapTypeControl:  false ,
            scaleControl:  false ,
            streetViewControl:  false ,
            rotateControl:  false ,
            fullscreenControl:  false ,
            clickableIcons: false,
            styles: [{"featureType": "administrative","elementType": "geometry","stylers": [{"visibility": "off"}]},
                {"featureType": "poi","stylers": [{"visibility": "off"}]},
                {"featureType": "road","elementType": "labels.icon","stylers": [{"visibility": "off"}]},
                {"featureType": "transit","stylers": [{"visibility": "off"}]}]
        };

        this.route_map = new google.maps.Map(mapCanvas, mapOptions);

        this.RouteMapAddRoute(this.route_map);
    },    

    RouteMapAddRoute: function(map) {

        var lineSymbol = {
            path: google.maps.SymbolPath.FORWARD_CLOSED_ARROW
        };

        this.route_path_bounds = new google.maps.LatLngBounds();


        for (var i = 0; i < this.route_orders.length; i++) {
            this.RouteMapAddMarkerOrder(this.route_orders[i], map);

            this.route_path_bounds.extend(
                new google.maps.LatLng(
                    this.route_orders[i].user_lat,
                    this.route_orders[i].user_lon,
            ));
        }

        let $this = this;
        setTimeout(function () {
            $this.RouteMapresize();
        }, 1000);

        google.maps.event.addDomListener(window, 'resize', this.RouteMapresize);
    },    

    RouteMapAddMarkerOrder: function(order, map) {
        let marker = new google.maps.Marker({
            position: {
                lat: parseFloat(order.user_lat),
                lng: parseFloat(order.user_lon)
            },

            label: {
                id: order.id,
                text: order.formatted_start_time,                
                fontFamily: "Rubik, sans-serif",
                fontWeight: "bold",
                fontSize: "10px",
                color: "#ffffff",
                lineHeight: "50px",
            },

            animation: '',

            icon: "service-list/route/marker?color_key=" + order.colorKey,

            map: map,
        });

        this.route_map_markers.push(marker);

        let $this = this;

        google.maps.event.addListener(marker, 'click', function () {
            let orderInfo = order;
            console.log("order: ", orderInfo);

            let select_vehicles =
                '<div class="row mb-2">' +
                    '<div class="col-2 text-left">' +
                        '<img src="service-list/route/marker?color_key=' + order.colorKey + '" />' +
                    '</div>' +
                    '<div class="col">' +
                        '<select id="worker-selector-route" class="worker-selector-route form-control modal-select" data-order_id="' + order.id + '" data-old_worker_id="' + order.worker_id + '"' + '">' +
                            '<option disabled value="">Choose worker</option>' + $this.getOptionsWithSelectedWorkersById(order.worker_id) +
                        '</select>' +
                        '<label for="service" class="arrow select position-absolute" style="right: 25px"></label>' +
                    '</div>' +
                '</div>';

            select_vehicles +=
                '<div class="row">' +
                    '<div class="col-2 text-right"></div>' +
                    '<div class="col">' + order.formatted_start_time + ' - ' + order.formatted_end_time + '</div>' +
                '</div>';

            select_vehicles +=
                '<div class="row">' +
                    '<div class="col-2 text-right">' + (order.route_overload ? '<span style="font-weight: bold; color:red">Overload</span>' : '&nbsp;') + '</div>' +
                    '<div class="col">Customer: ' + order.customer.first_name + ' ' + order.customer.last_name + '</div>' +
                '</div>';

            select_vehicles +=
                '<div class="row">' +
                    '<div class="col-2 text-right">' + (order.route_new ? '<span style="font-weight: bold; color:red">New</span>' : '&nbsp;') + '</div>' +
                    '<div class="col">Address: ' + order.customer.zip_code + ', ' + order.customer.city + ', ' + order.customer.address + ', ' + order.customer.apartment + '</div>' +
                '</div>';

            $('#route-map-workers-modal-select').html(select_vehicles);

            $(".worker-selector-route option").removeClass('d-none');

            let selector = '';
            let worker_ids = $this.workers_by_orders['order_' + order.id];
            
            for (let i = 0; i < worker_ids.length; i++) {
                selector += ".worker-selector-route option[value='" + worker_ids[i] + "']";
                if (i < worker_ids.length - 1) selector += ", ";
            }

            $(selector).addClass('d-none');

            $('#route-map-workers-modal').modal('show');
        });
    },  

    RouteMapSetVehicles: function(vehicles) {        
        $('#route-vehicles').html('');


        this.route_vehicles = vehicles;

        this.route_vehicles.forEach(function(item, key) {
            let mapIconColor = item.route == true ? "#d9f4fa" : "#1779FF";

            let v_row = '' +
                '<div class="d-flex justify-content-between mb-2">' +
                    '<div>' +
                        '<div class="text-left d-inline-block mr-3">' +
                            '<img src="service-list/route/marker?color_key=' + key + '" />' +
                        '</div>' +
                        '<div class="d-inline-block">' +
                            '<p class="m-0 pt-2 worker-name" data-worker_id="' + item.id + '">' + item.first_name + " " + item.last_name  + '</>' +
                        '</div>' +
                    '</div>' +
                    '<div>' +
                        '<button class="mr-3 btn optimize-button optimize-button-' + item.id + ' ' + ((item.route == true && item.change == false) ? "btn-outline-secondary" : "btn-outline-primary") + '"'
                        + ((item.route == true && item.change == false) ? " disabled" : "")  
                        + ' data-worker_id="' + item.id + '"'
                        + ' data-color_key="' + key + '"' 
                        + '>Optimize</button>' +
                        '<div style="display: none; padding: 8px; text-align: center;" class="optimize-loading-' + item.id + '">Loading ...</div>' +
                    
                    
                        '<button class="btn review-button ' + (item.route == true ? "btn-outline-primary" : "btn-outline-secondary") + '"'
                            + " data-worker_id='" + item.id + "'"
                            + " data-color_key='" + key + "'"
                            + (item.route == true ? "" : " disabled") + '>'
                            + '<svg width="20" height="20" viewBox="0 0 32 30" fill="none" xmlns="http://www.w3.org/2000/svg">' +
                                '<path d="M1.33337 6.99999V28.3333L10.6667 23L21.3334 28.3333L30.6667 23V1.66666L21.3334 6.99999L10.6667 1.66666L1.33337 6.99999Z" stroke="#D84560" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>' +
                                '<path d="M10.6666 1.66666V23" stroke="#D84560" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>' +
                                '<path d="M21.3334 7V28.3333" stroke="#D84560" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>' +
                            '</svg>' +
                            ' Review ' +
                        '</button>' +
                    '</div>'
                '</div>' +
                (item.route_orders ?
                '<div class="row">' +
                    '<div class="col pl-5 mb-3">' +
                    item.route_orders + ' Orders, ' + item.route_times + ' driving, ' + (item.route_waiting_time) + ' idle, ' + (item.route_distance / 1609.34).toFixed(1) +' miles' +
                    (item.route_new > 0 ? ' / <span style="color: red">' + item.route_new + ' new</span>' : '') +
                    (item.route_overload > 0 ? ' / <span style="color: red">' + item.route_overload + ' overload</span>' : '') +
                    '</div>' +
                '</div>' : '' ) +
                '';

            $('#route-vehicles').append(v_row);
        });
    },

    getOptionsWithSelectedWorkersById: function(vehicle_id) {
        let route_vehicles_all_options_html = ''

        return route_vehicles_all_options_html;
    },

    RouteMapresize: function() {
        this.route_map.setCenter(this.route_map_center);
        this.route_map.fitBounds(this.route_path_bounds);
    },

    RouteMapModalReview: function(worker_id, color_key = null) {
        if (color_key !== null) this.current_color_key = color_key;

        let $this = this;

        $.ajax({
            type: 'GET',
            url: '/service-list/route/review',
            data: ({
                date: $this.route_modal_date,
                worker_id: worker_id,
            }),
            success: function (response) {
                $('#route-map-review-modal-date').html(response.date_string);
                $('#route-map-review-modal-title').html('Route Review (Worker: ' + $(".worker-name[data-worker_id=" + worker_id + "]").html() + ')');
                $('#route-map-review-modal-orders-counts').html('(Orders: ' + response.orders_count + ')');

                $('#route-review-optimize-button').data('worker_id', worker_id);
                $('#route-review-optimize-button').data('date', $this.route_modal_date);

                $('#route-review-recalculate-button').data('worker_id', worker_id);
                $('#route-review-recalculate-button').data('vehicle_route_id', response.vehicle_route_id);
                $('#route-review-recalculate-button').data('date', $this.route_modal_date);

                if (response.route_optimization_lock == 0) {
                    $('#route-review-optimize-button')
                        .removeClass('btn-outline-primary')
                        .addClass('btn-outline-secondary')
                        .prop('disabled', true);
                } else {
                    $('#route-review-optimize-button')
                        .removeClass('btn-outline-secondary')
                        .addClass('btn-outline-primary')
                        .prop('disabled', false);
                }

                $this.RouteDisplayMapReview(response.worker_id, response.paths, response.lines);

                $('#route-map-review-list').html('');

                $('#route-map-review-action').show();

                // table title
                let v_row = '' +
                    '<tr>' +
                    '<th>#</th>' +
                    '<th colspan="2">Scheduled Windows</th>' +
                    '<th>Arrival</th>' +
                    '<th>Competed</th>' +
                    '<th>Address</th>' +
                    '<th>Distance</th>' +
                    '</tr>' +
                    '';

                response.paths.forEach(function(item){

                    v_row += '' +
                        '<tr style="' +
                                (item.arrival =='Overload' ? "color: red; font-weight: bold;" : "") +
                                (item.arrival =='New' ? "color: blue; font-weight: bold;" : "") +
                                ((item.status =='completed' || (item.status =='cancel')) ? "color: gray;" : "") +
                        '">' +
                            '<td>' +
                                item.position +
                            '</td>' +
                            '<td>' +
                                item.begin_time + " - " + item.end_time +
                            '</td>' +
                            '<td>' +
                                item.work_begin_time + " - " + item.work_end_time +
                            '</td>' +                          
                            '<td>' +
                               item.arrival +
                            '</td>' +
                            '<td>' +
                               item.completed +
                            '</td>' +
                            '<td>' +
                                item.address +
                            '</td>' +
                            '<td>' +
                                (item.distance / 1609.34).toFixed(1) + ' miles' +
                            '</td>' +
                        '</tr>' +
                        '';
                });

                $('#route-map-review-list').append(
                    '<table class="table table-hover">' +
                    v_row +
                    '</table>'
                );

                $('#route-map-modal-review').modal('show');
            }
        });
    },

    RouteDisplayMapReview: function(worker_id, paths, lines) {

        this.route_map_review_center = new google.maps.LatLng(40.7198749, -73.985987);

        var mapCanvas = document.getElementById('route-map-review');

        var mapOptions = {
            zoom: 12,
            mapTypeId: google.maps.MapTypeId.ROADMAP,
            disableDefaultUI:  false ,
            scrollwheel:  true ,
            zoomControl:  true ,
            mapTypeControl:  false ,
            scaleControl:  false ,
            streetViewControl:  false ,
            rotateControl:  false ,
            fullscreenControl:  false ,
            clickableIcons: false,
            styles: [{"featureType": "administrative","elementType": "geometry","stylers": [{"visibility": "off"}]},
                {"featureType": "poi","stylers": [{"visibility": "off"}]},
                {"featureType": "road","elementType": "labels.icon","stylers": [{"visibility": "off"}]},
                {"featureType": "transit","stylers": [{"visibility": "off"}]}]
        };

        this.route_map_review = new google.maps.Map(mapCanvas, mapOptions);

        this.RouteMapAddRouteReview(this.route_map_review, worker_id, paths, lines);
    },

    RouteMapAddRouteReview: function(map, worker_id, paths, lines) {

        var lineSymbol = {
            path: google.maps.SymbolPath.FORWARD_CLOSED_ARROW
        };

        this.route_map_review_path_bounds = new google.maps.LatLngBounds();

        let tmp_paths = [];

        for (var i = 0; i < paths.length; i++) {

            if (paths[i].status == "routed" || paths[i].status == "start" || paths[i].status == "end")
            {

                tmp_paths.push({
                    lat: parseFloat(paths[i].lat),
                    lng: parseFloat(paths[i].lon),
                });

                console.log('paths[i]', paths[i], paths[i].position.toString());

                this.RouteMapAddMarkerReview(paths[i].position.toString(), paths[i], map);

                this.route_map_review_path_bounds.extend(
                    new google.maps.LatLng(
                        paths[i].lat,
                        paths[i].lon
                    )
                );
            }

        }

        for (let i = 0; i < lines.length; i++) {

            tmp_paths = [];
            for (let j = 0; j < lines[i].points.length; j++) {
                tmp_paths.push({
                    lat : parseFloat(lines[i].points[j].lat),
                    lng : parseFloat(lines[i].points[j].lng),
                });
            }

            var flightPath = new google.maps.Polyline({
                path: tmp_paths,
                geodesic: true,
                icons: [{
                    icon: lineSymbol,
                    offset: '100%'
                }],
                strokeColor: lines[i].color,
                strokeOpacity: 1.0,
                strokeWeight: 2
            });
            flightPath.setMap(map);

        }

        let $this = this; 

        setTimeout(function () {
            $this.RouteMapResizeReview();
        }, 1000);

        google.maps.event.addDomListener(window, 'resize', this.RouteMapResizeReview);
    },    

    RouteMapAddMarkerReview: function(title, point, map) {
        var marker = new google.maps.Marker({

            title: title,

            position: {
                lat: parseFloat(point.lat),
                lng: parseFloat(point.lon)
            },

            label: {
                id: point.id, //"107685_pickup",
                text: title, //"7:00P",
                fontFamily: "Rubik, sans-serif",
                fontWeight: "bold",
                fontSize: "10px",
                color: "#ffffff",
                lineHeight: "50px",
                paddingBottom: "5px",
            },

            animation:  '' ,

            icon: "service-list/route/marker?color_key=" + this.current_color_key,

            map: map,
        });

        this.route_map_review_markers.push(marker);

        this.RouteMapResizeReview();
    },    

    RouteMapResizeReview: function() {
        this.route_map_review.setCenter(this.route_map_review_center);
        this.route_map_review.fitBounds(this.route_map_review_path_bounds);
    },         

    getOptionsWithSelectedWorkersById: function(worker_id) {        
        let route_vehicles_all_options_html = ''
        this.route_workers_all.forEach(function(item) {
            let same_id = item.id == worker_id;

            route_vehicles_all_options_html += '<option value="' + item.id + '"'
                + (same_id ? " selected " : "")
                + '>' 
                + item.first_name + ' ' + item.last_name 
                + '</option>';
        });

        return route_vehicles_all_options_html;
    },

    RouteMapModelWorkerSelected: function(selected_worker_id, prev_worker_id, order_id) {
        let marker_select = null;

        this.route_map_markers.forEach(function(item) {
            if (item.label && (item.label.id == order_id))
                marker_select = item;
        });

        let $this = this;

        if (marker_select) {
            $.ajax({
                type: 'POST',
                url: '/service-list/route/vehicle/set',
                data: ({
                    date: $this.route_modal_date,
                    select_worker_id: selected_worker_id,
                    prev_worker_id: prev_worker_id,
                    order_id: order_id,
                }),
                success: function (response) {

                    while($this.route_map_markers.length) { $this.route_map_markers.pop().setMap(null); }

                    $this.RouteMapSetVehicles(response.vehicles);

                    for (var i = 0; i < response.orders.length; i++) {
                        $this.RouteMapAddMarkerOrder(response.orders[i], $this.route_map);
                        $this.route_path_bounds.extend(
                            new google.maps.LatLng(
                                response.orders[i].user_lat,
                                response.orders[i].user_lon
                            )
                        );
                    }

                    $('#route-map-workers-modal').modal('hide');
                }
            });
        }
    }    
}
